import { render } from "./DexTableBody.vue?vue&type=template&id=2e5dfd86"
import script from "./DexTableBody.vue?vue&type=script&lang=js"
export * from "./DexTableBody.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__